import { render, staticRenderFns } from "./SelectorBadgeList.vue?vue&type=template&id=2b838bf4&scoped=true"
import script from "./SelectorBadgeList.vue?vue&type=script&lang=js"
export * from "./SelectorBadgeList.vue?vue&type=script&lang=js"
import style0 from "./SelectorBadgeList.vue?vue&type=style&index=0&id=2b838bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b838bf4",
  null
  
)

export default component.exports